module.exports = __webpack_public_path__ + "img/ic_200_service.0209a21e.png";